<!-- Extended Logs Section -->
<div class="extended-logs-section">
  <div class="logs-header">
    <h3>
      <mat-icon>history</mat-icon>
      {{ title }}
    </h3>
    <div class="header-actions">
      <span class="logs-count">{{ totalLogs || 0 }} bejegyzés</span>
      <button mat-button class="refresh-btn" (click)="refreshLogs()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        <span>Frissítés</span>
      </button>
    </div>
  </div>

  <!-- Shared Filters Component -->
  <app-shared-filters 
    [pageName]="'extended_logs'"
    [allowSticky]="false"
    [hideProductFields]="true"
    [hidePolicyNumberField]="true"
    [useLogsDateLabels]="true"
    [useLogsLabels]="true"
    [customStatusOptions]="customStatusOptions"
    [customUserOptions]="customUserOptions"
    [lockUserFilter]="shouldDisableUserFilter"
    (filterChange)="onSharedFilterChange($event)">
  </app-shared-filters>
  
  <!-- No results state (szűrés után nincs találat) -->
  @if (!loading && !error && totalLogs === 0 && hasActiveFilters) {
    <div class="no-results-state">
      <mat-icon>search_off</mat-icon>
      <p>Nincs találat.</p>
    </div>
  }
  
  <!-- Logs table component (handles loading/error states internally) -->
  <app-extended-logs-table
    [paginatedLogs]="paginatedLogs"
    [loading]="loading"
    [error]="error"
    [totalLogs]="totalLogs"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    (pageChange)="onPageChange($event)">
  </app-extended-logs-table>
  
  <!-- Empty state (egyáltalán nincsenek log bejegyzések) -->
  @if (totalLogs === 0 && !loading && !error && !hasActiveFilters) {
    <div class="empty-state">
      <mat-icon>history</mat-icon>
      <p>Még nincsenek log bejegyzések.</p>
    </div>
  }
</div>